import { api } from "@/APIRequests";
import type { ModalityTextResponse } from "@/core/types";

export async function getModalityText(patientId: string): Promise<ModalityTextResponse> {
  return api.carePlanTyped.get_modality_text({
    params: { showLoader: false },
    patientId,
  });
}
